import { normalizeApiError } from '../api/apiError';

const MESSAGES: Record<string, string> = {
  ATTENDANCE_CORRECTION_NOT_FOUND:
    'The attendance correction request was not found.',
  ATTENDANCE_ALREADY_COMPLETE:
    'Check-in, check-out, and break times already exist for this date.',
  ATTENDANCE_CORRECTION_NOT_ALLOWED:
    'A manual attendance correction is not allowed for this date.',
  ATTENDANCE_CORRECTION_PENDING:
    'A correction request is already pending for this date.',
  ATTENDANCE_CORRECTION_NOT_CANCELLABLE:
    'This correction request can no longer be canceled.',
  INVALID_STATE:
    'This attendance correction request is not pending approval.',
  WORKFLOW_NOT_CONFIGURED: 'The approval workflow is not configured.',
  ACCESS_DENIED: 'You do not have permission to perform this action.',
  VALIDATION_ERROR: 'Please check the attendance correction details you entered.',
  INVALID_DATE_RANGE: 'The selected date range is invalid.',
  NETWORK_ERROR: 'Unable to connect to the server.',
  REQUEST_TIMEOUT: 'The server took too long to respond.',
  ATTENDANCE_CORRECTION_APPLY_FAILED:
    'The attendance correction could not be applied.',
  INTERNAL_SERVER_ERROR: 'Unable to complete the attendance correction request.',
};

const PREFER_API_MESSAGE = new Set([
  'VALIDATION_ERROR',
  'ATTENDANCE_CORRECTION_APPLY_FAILED',
  'INVALID_STATE',
]);

export function attendanceCorrectionErrorMessage(
  error: unknown,
  fallback = 'Unable to load attendance correction requests.',
): string {
  if (
    typeof error === 'object' &&
    error !== null &&
    'code' in error &&
    typeof (error as { code?: unknown }).code === 'string'
  ) {
    const code = (error as { code: string }).code;
    const message =
      'message' in error && typeof (error as { message?: unknown }).message === 'string'
        ? (error as { message: string }).message.trim()
        : '';
    if (PREFER_API_MESSAGE.has(code) && message) return message;
    if (MESSAGES[code]) return MESSAGES[code];
  }

  const apiError = normalizeApiError(error);
  if (apiError.code === 'VALIDATION_ERROR' && apiError.message?.trim()) {
    return apiError.message.trim();
  }
  if (apiError.code && MESSAGES[apiError.code]) {
    return MESSAGES[apiError.code];
  }
  if (apiError.message?.trim()) {
    return apiError.message.trim();
  }
  return fallback;
}
